import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import SelectField from '~fields/SelectField';
import TagField from '~fields/TagField';
import OpenHours from '../formik/components/OpenHours';

import { fetchDeliveryAddresses } from '../../services/api.helpers';

const InstrumentsForm = props => {
  const { formik, timeInfo, organizations } = props;
  const {
    values: { organization },
  } = formik;
  const [addresses, setAddresses] = useState([]);

  const fetchAddresses = async orgId => {
    try {
      if (!orgId) throw new Error('Cost centre code not defined');
      const addresses = await fetchDeliveryAddresses(orgId);
      setAddresses(addresses);
    } catch (e) {
      setAddresses([]);
      console.warn(
        `fetchAddresses: Addresses not found for orgId: ${orgId}. ${e}`
      );
    }
  };

  useEffect(() => {
    const org = organizations.find(o => o.id === organization?.value);
    if (org) {
      fetchAddresses(org.costCentreCode);
    }
  }, [organization, organizations]);

  const organizationOptions = organizations.map(o => ({
    value: o.id,
    label: o.name,
  }));

  return (
    <>
      <FieldWrapper>
        <SelectField
          fallbackLabel="Yksikkö"
          name="organization"
          options={organizationOptions}
          fallbackPlaceholder="Valitse"
          required
        />
      </FieldWrapper>

      <FieldWrapper>
        <TagField
          label="Noutopaikka"
          name="pickupAddress"
          options={addresses.map(o => ({ value: o.address, label: o.address }))}
          required
        />
        {!addresses?.length && (
          <div style={{ marginTop: '20px' }}>
            Valitse ensiksi yksikkö, jolla on noutopaikkoja
          </div>
        )}
      </FieldWrapper>

      {
        timeInfo && (
          <OpenHours
            timeInfo={timeInfo}
            urgency={{
              canBeUrgent: true,
            }}
          />
        ) // Show generic open hours
      }
    </>
  );
};

const FieldWrapper = props => <FieldContainer>{props.children}</FieldContainer>;

const FieldContainer = styled.div`
  margin-bottom: 24px;
`;

export default InstrumentsForm;
